import deliveryDateClass from "common/utils/delivery-date/delivery-date-class";
import deliveryDateFormClass from "common/utils/delivery-date/delivery-date-form-class";
import "./delivery.scss";

const $getDeliveryDate = () =>
  document.querySelector(".js-jiffytransfers-landing-v2-hero-section-delivery-delivery-date");

const errorCallback = hasError => {
  $getDeliveryDate()?.classList.toggle("error", hasError);
};

export default () => {
  deliveryDateClass().init();
  deliveryDateFormClass(errorCallback).init();
};
